module.exports = __webpack_public_path__ + "img/weixin-code.3be859f6.png";